export class Constants {
    public static me = {
        name: 'Cristtopher Quintana T.',
        description: 'Family Father 👨‍👩‍👧‍👦 | Software Engineer 💻 | Chile 🇨🇱 | Patagonia 🏔'
    };
}
